"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Text = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Text"));
var _Stack = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Stack"));
var _handleKeyDown = _interopRequireDefault(require("@kiwicom/orbit-components/lib/utils/handleKeyDown"));
var _CountryFlag = _interopRequireDefault(require("@kiwicom/orbit-components/lib/CountryFlag"));
var _Trip2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/icons/Trip"));
var _jsxRuntime = require("react/jsx-runtime");
var _Trip;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const SelectableTile = _ref => {
  let {
    title,
    flag,
    options,
    selected = false,
    onSelect,
    dataTest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _clsx.default)("relative col-span-1 rounded-300 border-2 py-300 px-400 cursor-pointer hover:shadow-level2 *:h-full", selected ? "border-blue-normal" : "border-cloud-normal hover:border-cloud-dark"),
    role: "button",
    "data-test": dataTest,
    tabIndex: 0,
    onClick: onSelect,
    onKeyDown: (0, _handleKeyDown.default)(onSelect),
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
      direction: "row",
      align: "center",
      children: [flag != null && (flag === "" ? _Trip || (_Trip = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Trip2.default, {
        size: "small",
        ariaHidden: true
      })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CountryFlag.default, {
        code: flag,
        name: "",
        role: "presentation"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Stack.default, {
        spacing: "100",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "primary",
          size: "normal",
          children: title
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          type: "secondary",
          size: "small",
          children: typeof options === "string" ? options : options.join(", ")
        })]
      })]
    })
  });
};
var _default = exports.default = SelectableTile;